import React from 'react'
import { observer } from 'mobx-react-lite'

import { StoreMultiProductSwitch } from './StoreMultiProductSwitch'

import { useLogic, useStore } from '../hooks/storeHook'

export const YandexMarketMultiProductSwitch =
  observer(() => {
    const {user} = useStore()
    const {setYandexMarketMultiProducts} = useLogic()

    if (!user) {
      throw new Error('Not authorized')
    }

    return <StoreMultiProductSwitch
      allowMultiProducts={user.allowMultiYandexMarketProducts}
      setMultiProducts={setYandexMarketMultiProducts}
    />
  })
